import { MAINTENANCE_STATUS_REQUEST, 
         MAINTENANCE_STATUS_SUCCESS, 
         MAINTENANCE_STATUS_FAILURE } from "../actions/statusActions";
import moment from 'moment';

const init = {
    nonPivLogin: undefined,
    lastRequestTime: moment.utc().unix(),
    inError: false,
    status: ""
};

export default (state=init, action) =>
{
    switch(action.type) {
        case MAINTENANCE_STATUS_REQUEST: 
            return {...state, 
                nonPivLogin: undefined,
                lastRequestTime: moment.utc().unix(),
                inError: false,
                status: "pending"
            }
        case MAINTENANCE_STATUS_SUCCESS: 
            return {...state, 
                nonPivLogin: action.payload.nonPivLogin,
                lastRequestTime: moment.utc().unix(),
                inError: false,
                status: "success"
            }
        case MAINTENANCE_STATUS_FAILURE: 
            return {...state, 
                nonPivLogin: undefined,
                lastRequestTime: moment.utc().unix(),
                inError: true,
                status: "failure"
            }
        default: return {...state};
    }
    
}
